import React from 'react';

import { bemCssModules, getTestId } from '@utils';
import { useTimeout } from '@utils/hooks';

import style from './Toast.scss';

const cn = bemCssModules(style, 'Toast');
const ti = getTestId('Toast');

const HIDE_TIMEOUT = 3000;

export type TToast = {
  message: string;
  onClose?: () => void;
};

const Toast: CustomFC<TToast> = props => {
  const { className, message, onClose } = props;

  useTimeout(() => onClose?.(), HIDE_TIMEOUT);

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      <small>{message}</small>
    </div>
  );
};

export default Toast;
